import styled from "styled-components";
import { resetButtonStyling } from "styles/commonStyles";
import fonts from "styles/fonts";

export const ClientDetailsContainer = styled.div`
  margin-top: 3em;
  padding-bottom: 2em;
`;

export const InfoBoxContainer = styled.div`
  margin-left: 1em;
`;

export const ContentDiv = styled.div`
  font-size: ${fonts.smallMedium};
  margin-left: 1em;
`;

export const RequestSecretButton = styled.button`
  ${resetButtonStyling};
  color: black;
`;

export const CreateQueueContainer = styled.div`
  padding-bottom: 2em;
  margin-left: 1em;
  display: flex;
  justify-content: space-between;
  align-items: start;

  > p {
    font-size: ${fonts.xSmall};
  }
`;
